{
    "ConfigureAgents_Add_Title": "Ajouter un nouvel agent",
    "ConfigureAgents_Modify_Title": "Modifier l'agent",
    "ConfigureAgents_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues à la fermeture.",
    "ConfigureAgents_PromptConfirm": "Oui",
    "ConfigureAgents_PromptCancel": "Annuler",
    "ConfigureAgents_Tabs_Details": "Détails de l'agent",
    "ConfigureAgents_Tabs_Advanced": "Avancé",
    "ConfigureAgents_Tabs_Omnichannel": "Omnichannel",
    "ConfigureAgents_Footer_Help": "Aide ?",
    "ConfigureAgents_Footer_Submit": "Économiser",
    "ConfigureAgents_Footer_Cancel": "Annuler",
    "NAME": "ConfigureAgents"
}